/* eslint jsx-a11y/aria-role: 0 */
import React from 'react';
import PropTypes from 'prop-types';

/* Fieldtest -- Treez -- Purchase Pixel */
const FieldTestPurchase = ({orderId, totalCost}) => {
  return <img height="1" width="1" style={{borderStyle: 'none'}} alt="" src={`//insight.adsrvr.org/track/conv/?adv=efj5q1x&ct=0:5kayo70&fmt=3&v=${totalCost}&orderid=${orderId}`}/>;
};

FieldTestPurchase.propTypes = {
  orderId: PropTypes.string.isRequired,
  totalCost: PropTypes.number.isRequired
};

export default FieldTestPurchase;



// WEBPACK FOOTER //
// ./src/components/FieldTestPurchase/FieldTestPurchase.jsx